import React, {
  useState,
  useMemo,
  useRef,
} from 'react';
import { Box, Grid } from '@chakra-ui/react';
import { useParams, useNavigate } from 'react-router-dom';

import TopLeft from './TopLeft.js'
import TopRight from './TopRight.js'
import BottomLeft from './BottomLeft.js'
import BottomRight from './BottomRight.js'
import apiClient from '../../clients/apiClient.js';
import ConversationPanel from './ConversationPanel.js';

const ReviewForm = () => {
  const [selectedTab, setSelectedTab] = useState("")
  const { formId } = useParams()
  const [formData, setFormData] = useState(null)
  const [updatedData, setUpdatedData] = useState([])
  const [originalData, setOriginalData] = useState(null)
  const [sectionData, setSectionData] = useState([])
  const [selectedSection, setSelectedSection] = useState('')
  const [scrollToQuestionCard, setScrollToQuestionCard] = useState(null)
  const [allCollaborators, setAllCollaborators] = useState([])
  const [selectedFilter, setSelectedFilter] = useState("all")
  const [isEntityChatOpen, setIsEntityChatOpen] = useState(false)
  const [entityChatData, setEntityChatData] = useState(null)
  const childRefs = useRef({});
  const [selectedRefId, setSelectedRefId] = useState(null);
  const [selectedConversationTab, setSelectedConversationTab] = React.useState("collaborator_chat");
  
  const createRef = (id) => {
    if (!childRefs.current[id]) {
      childRefs.current[id] = React.createRef();
    }

    return childRefs.current[id];
  }

  const applySuggestion = (data) => {
    console.log("[Form] Applying suggestion", data, selectedRefId, childRefs.current[selectedRefId])
    if (selectedRefId && childRefs.current[selectedRefId]?.current) {
      childRefs.current[selectedRefId].current.applySuggestion(data);
    }
  };

  React.useEffect(() => {
    apiClient.get('/account-settings/team-management').then(({ data }) => {
      setAllCollaborators(data.employees_info);
    })
  }, [])

  React.useEffect(() => {
    const req = {
      form_id: formId
    }
    apiClient.get('/forms/get-form', {params: req} ).then(({ data }) => {
      data.sections?.sort((a,b) => {
        return a.section_name.localeCompare(b.section_name)
      })
      for (let i = 0; i < data?.sections?.length; i++) {
        data.sections[i].index = i;
      }
      setFormData(data);
      setOriginalData(data);
    });
    }, []);
    
    React.useEffect(() => {
      if (formData === null) {
        return;
      } 
      // let bottomLeftData = [];
      let selectedSectionLocal = selectedSection
      for (let i = 0; i < formData?.sections?.length; i++) {
        if (selectedSectionLocal === '') {
          selectedSectionLocal = formData?.sections[i].index
        }
      }
      setSectionData(formData?.sections);
    
      const pageKey = window.location.pathname;
      const lastSelectedSection = JSON.parse(sessionStorage.getItem(`page_${pageKey}_selectedSection`))?.selectedSection;
      // console.log("[Form] Form data during session", formData)
      if (lastSelectedSection > 0) {
        setSelectedSection(lastSelectedSection)
      } else {
        setSelectedSection(selectedSectionLocal);
      }
      
      const lastSelectedTab = JSON.parse(sessionStorage.getItem(`page_${pageKey}_selectedTab`))?.selectedTab;
      if (lastSelectedTab) {
        setSelectedTab(lastSelectedTab)
      } else {
        setSelectedTab("fill")
      }
      // console.log("[Form] Fetching data from session", lastSelectedSection, selectedTab)

    }, [formData])

  React.useEffect(() => {
    // console.log("[Form] Incoming data in session selectedSection",selectedSection,"tab",selectedTab)
    if (selectedSection != null && selectedSection !== '') {
      const pageKey = window.location.pathname;
      sessionStorage.setItem(`page_${pageKey}_selectedSection`, JSON.stringify({ selectedSection: selectedSection }));
      // console.log("[Form] Storing data in session selectedSection",selectedSection,"-")
      // localStorage.setItem("selectedSection", selectedSection);
    }
    if (selectedTab) {
      const pageKey = window.location.pathname;
      sessionStorage.setItem(`page_${pageKey}_selectedTab`, JSON.stringify({ selectedTab: selectedTab }));
      // console.log("[Form] Storing data in session selectedTab",selectedTab)
      // localStorage.setItem("selectedTab", selectedTab);
    };
  }, [selectedSection, selectedTab]);

  console.log("[Form][UseEffect] Form data is", formData)
  return (
    <Box position="relative" height="100vh" p={0}>
      <Grid
        templateAreas={`"image logbar"
                        "pagelist pagecontent"`}
        gridTemplateRows={'80px 14fr'}
        gridTemplateColumns={'268px 2fr'}
        gap={0}
        p={0}
        height="100vh"
        onClick={() => {isEntityChatOpen && setIsEntityChatOpen(false)}}
      >
        <TopLeft />
        <TopRight 
          formData={formData} 
          selectedTab={selectedTab} 
          selectedSection={selectedSection} 
          setSelectedTab={setSelectedTab}
          updatedData={updatedData}
          setFormData={setFormData}
          setUpdatedData={setUpdatedData}
        />
        <BottomLeft 
          sectionData={sectionData}
          selectedSection={selectedSection}
          setSelectedSection={setSelectedSection}
          setScrollToQuestionCard={setScrollToQuestionCard}
          setSelectedTab={setSelectedTab}
          isCollaborator={formData?.is_collaborator}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          taskName={formData?.metadata?.task_name}
        />

        {/* Bottom Right: Text paragraphs */}
        <BottomRight 
          formData={formData}
          selectedTab={selectedTab}
          selectedSection={selectedSection}
          setFormData={setFormData}
          setUpdatedData={setUpdatedData}
          scrollToQuestionCard={scrollToQuestionCard}
          setScrollToQuestionCard={setScrollToQuestionCard}
          allCollaborators={allCollaborators}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          setIsEntityChatOpen={setIsEntityChatOpen}
          setEntityChatData={setEntityChatData}
          createRef={createRef}
          setSelectedRefId={setSelectedRefId}
          selectedConversationTab={selectedConversationTab}
          setSelectedConversationTab={setSelectedConversationTab}
        />
          {/* Horizontal Divider */}
        <Box
          gridColumn="1 / span 2" // Spans across all columns
          gridRow="1 / 2" // Positioned between the first and second rows
          height="1px"
          bg="#E5E5E5"
          // transform="translateY(+250%)"
          alignSelf="end" // Aligns to the bottom of the first row
        />

        {/* Vertical Divider */}
        <Box
          gridColumn="1 / 2" // Positioned between the first and second columns
          gridRow="2 / span 2" // Spans all rows
          width="1px"
          // transform="translateX(+250%)"
          bg="#E5E5E5"
          justifySelf="end" // Aligns to the right of the first column
        />
      </Grid>
        {isEntityChatOpen && (
          <ConversationPanel 
            setIsEntityChatOpen={setIsEntityChatOpen}
            entityChatData={entityChatData}
            setEntityChatData={setEntityChatData}
            allCollaborators={allCollaborators}
            applySuggestion={applySuggestion}
            selectedConversationTab={selectedConversationTab}
            setSelectedConversationTab={setSelectedConversationTab}
          />
        )}
    </Box>
  );
};

export default ReviewForm;
